import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';
import { v4 as uuidv4 } from 'uuid';

export class PriceDataStore {
  root;
  priceStream;

  trades = {};
  lastTrade = {};
  summaries = {};
  lastQuote = {};
  timeSales = {};

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.listenForPriceMessages();
  }
  messageMap = {
    trade: (msg) => this.handleTrade(msg),
    tradex: (msg) => this.handleTrade(msg),
    timesale: (msg) => this.handleTimesale(msg),
    summary: (msg) => this.handleSummary(msg),
    quote: (msg) => this.handleQuote(msg),
  };

  listenForPriceMessages = () => {
    this.priceStream = groupByFunction(
      'messageType',
      'stream',
      this.root.websocketSubject
    );
    this.priceStream.subscribe((msg) => {
      this.messageMap[msg.type](msg);
    });
    groupByFunction(
      'messageType',
      'removeSymbol',
      this.root.websocketSubject
    ).subscribe((msg) => {
      this.removeSymbol(msg);
    });
  };
  
  removeSymbol = (msg) => {
    const hash = `${msg.symbol}-${msg.datasource}`;
    if (this.trades[hash]) delete this.trades[hash];
    if (this.summaries[hash]) delete this.summaries[hash];
    if (this.lastTrade[hash]) delete this.lastTrade[hash];
    if (this.lastQuote[hash]) delete this.lastQuote[hash];
    if (this.timeSales[hash]) delete this.timeSales[hash];
  };

  handleTrade = (msg) => {
    const hash = `${msg.symbol}-${msg.from}`;
    this.lastTrade[hash] = msg;
    if (this.trades[hash]) {
      this.trades[hash].price = msg.price;
      this.trades[hash].timeStamp = msg.date;
      this.trades[hash].volume = msg.size;
    } else {
      this.trades[hash] = {
        price: msg.price,
        timeStamp: msg.date,
        volume: msg.size,
      };
    }
  };

  handleTimesale = (msg) => {
    const hash = `${msg.symbol}-${msg.from}`;
    this.lastTrade[hash] = msg;
    if (this.trades[hash]) {
      this.trades[hash].price = msg.last;
      this.trades[hash].timeStamp = msg.date;
      this.trades[hash].volume = msg.size;
    } else {
      this.trades[hash] = {
        price: msg.last,
        timeStamp: msg.date,
        volume: msg.size,
      };
    }
    if (this.lastQuote[hash]) {
      this.lastQuote[hash].bid = Number(msg.bid);
      this.lastQuote[hash].ask = Number(msg.ask);
    } else {
      this.lastQuote[hash] = {
        bid: Number(msg.bid),
        ask: Number(msg.ask),
      };
    }
    if (this.timeSales[hash]) {
      this.timeSales[hash].collection.unshift({
        bid: msg.bid,
        ask: msg.ask,
        last: msg.last,
        volume: Number(msg.size),
        id: uuidv4(),
      });
      // this.timeSales[hash].sum = this.timeSales[hash].sum + Number(msg.size);
      // this.timeSales[hash].squareSum =
      //   this.timeSales[hash].squareSum + Math.pow(Number(msg.size), 2);

      if (this.timeSales[hash].collection.length > 50) {
        this.timeSales[hash].collection.pop();
        // const removed = this.timeSales[hash].collection.pop();
        // this.timeSales[hash].sum =
        //   this.timeSales[hash].sum - Number(removed.volume);
        // this.timeSales[hash].squareSum =
        //   this.timeSales[hash].squareSum - Math.pow(Number(removed.volume), 2);
      }
      // this.timeSales[hash].average =
      //   this.timeSales[hash].sum / this.timeSales[hash].collection.length;
    } else {
      this.timeSales[hash] = {
        // sum: Number(msg.size),
        // squareSum: Math.pow(Number(msg.size), 2),
        // average: Number(msg.size),
        collection: [
          {
            bid: msg.bid,
            ask: msg.ask,
            last: msg.last,
            volume: Number(msg.size),
            id: uuidv4(),
          },
        ],
      };
    }
  };
  handleQuote = (msg) => {
    const hash = `${msg.symbol}-${msg.from}`;
    this.lastQuote[hash] = {
      bid: msg.bid,
      ask: msg.ask,
      bidTimeStamp: msg.biddate,
      askTimeStamp: msg.askdate,
    };
  };
  handleSummary = (msg) => {
    const hash = `${msg.symbol}-${msg.from}`;
    this.summaries[hash] = msg;
  };

  removeFromTradeStore = () => {};
}
